export class FunctionalityStateModel {
  metricsTier1?: boolean;
  metricsTier2?: boolean;
  metricsAggregationRunning12Months?: boolean;
  metricsAggregationThisWeekLastYear?: boolean;
  metricsAggregationThisMonthLastYear?: boolean;
  metricsAggregationYearToYear?: boolean;
  statisticsTier1?: boolean;
  statisticsTier2?: boolean;
  statisticsTier3?: boolean;
  statisticsDepthRunning12Months?: boolean;
  statisticsDepthActualNumbers?: boolean;
  statisticsDepthHistoricalData?: boolean;
  statisticsDepthComparisonsVsLastYear?: boolean;
  statisticsDepthPercentNumbers?: boolean;
  nextgenSurveyTool?: boolean;
  statfeedAccess?: boolean;
  manageUsers?: boolean;
  manageBilling?: boolean;
  manageWebnav?: boolean;
  manageFeedback?: boolean;
  manageCalendars?: boolean;
}
